/* eslint-disable */

export enum ReferralType {
  /** SMS - The customer's SMS number was invited. */
  SMS = "SMS",
  /** USERNAME_LINK - The customer followed a referral link to the marketing page. */
  USERNAME_LINK = "USERNAME_LINK",
  /** TRY_IT_NOW - The customer organically signed up on the marketing page. */
  TRY_IT_NOW = "TRY_IT_NOW",
  /** EMAIL - The customer's email address was invited. */
  EMAIL = "EMAIL",
  /** REWARD_CODE - The customer used the inviter's reward code. */
  REWARD_CODE = "REWARD_CODE",
  /** PAYMENT - A new customer was onboarded by receiving a payment. */
  PAYMENT = "PAYMENT",
}
